import { render } from "./ShowDialog.vue?vue&type=template&id=1b4a48be&scoped=true"
import script from "./ShowDialog.vue?vue&type=script&lang=js"
export * from "./ShowDialog.vue?vue&type=script&lang=js"

import "./ShowDialog.vue?vue&type=style&index=0&id=1b4a48be&scoped=true&lang=css"
import "./ShowDialog.vue?vue&type=style&index=1&id=1b4a48be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4a48be"]])

export default __exports__